// extracted by mini-css-extract-plugin
module.exports = {"contentRoot":"src_contentRoot__fsr3B"};